// services/data.service.ts

import {
  GetStudyDataRequest,
  StudyDataResponse,
  GetCompanyDataRequest,
  CompanyDataResponse,
} from '@/types/data';
import { api } from './index';

class DataService {
  // --------------------------------------- V3 - VERSION 3 ------------------------------------------

  /**
   * Get study data with comprehensive filtering (V3)
   * GET /v3/data/study
   * NEW IN V3 ✅
   */
  async getStudyData(params?: GetStudyDataRequest): Promise<StudyDataResponse> {
    try {
      const response = await api.get<StudyDataResponse>('/data/study', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching study data (V3):', error);
      throw error;
    }
  }

  /**
   * Get company data with detailed filtering (V3)
   * GET /v3/data/company
   * NEW IN V3 ✅
   */
  async getCompanyData(params?: GetCompanyDataRequest): Promise<CompanyDataResponse> {
    try {
      const response = await api.get<CompanyDataResponse>('/data/company', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching company data (V3):', error);
      throw error;
    }
  }
}

export const dataService = new DataService();
